import React, {Component} from 'react';
import Chart from "react-google-charts";

//cal rebre a través de props: participacio i abstencio en format numeric

class GraficParticipacio extends Component {	
    render() {          
     return (
         <div>
            {this.props.participacio&&this.props.abstencio && ( 
                <Chart
                    width={'100%'}
                    height={'200px'}
                    chartType="PieChart"
                    loader={<div>Carregant gràfic</div>}
                    data={[
                        ['Nom', 'Valor', { role: 'style' },],
                        ['Participació', this.props.participacio, 'color: #0D7AF5'],
                        ['Abstenció', this.props.abstencio, 'color: #e5e4e2']
                    ]}
                    options={{
                        // Just add this option
                        pieHole: 0.4,
                        slices: {
                            0: { color: '#0D7AF5' },
                            1: { color: '#e5e4e2' },
                        },
                    }}
                    rootProps={{ 'data-testid': '3' }}
                />
            )}
        </div>
      );
    }
  }

  export default GraficParticipacio;